
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkProjectCheckRuleSortOrderItemDto } from '../models/work-project-check-rule-sort-order-item-dto';

export function getUpdateSortOrderProjectCheckRulesDtoFormGroup() {
return new FormGroup({
    updates: new FormControl<WorkProjectCheckRuleSortOrderItemDto[]>([]),
})
;
}
      